<template>
	<div>
		<table class="my_table">
			<tbody>
				<tr v-if="is_edit===true">
					<td colspan="9">
						<el-button class="edit_btn" type="primary" plain size="small" @click="openIntro(list)">
							填写{{list.option.insect_pest_name}}说明</el-button>
					</td>
				</tr>
				<tr>
					<td colspan="2">组数</td>
					<td>单株采集方位</td>
					<td>数据1</td>
					<td>数据2</td>
					<td>数据3</td>
					<td>样图</td>
					<td>数据平均值</td>
					<td colspan="2" v-if="is_edit===true">操作</td>
				</tr>
			</tbody>
			<tbody v-for="(item,index) in list.option_list" :key="'tbody'+list.id+index">
				<tr v-for="(val,key) in item" :key="'tr'+index+key+list.id">
					<td colspan="2" rowspan="5" v-if="key==0">第{{index+1}}组</td>

					<td>{{val.name}}</td>
					<td>
						<span v-if="is_edit===true">
							<el-input size="small" style="width: 80px;" v-model="param1[index][val.type]" type="text">
							</el-input>
						</span>
						<span v-else>{{param1[index][val.type]}}</span>

					</td>
					<td>
						<span v-if="is_edit===true">
							<el-input size="small" style="width: 80px;" v-model="param2[index][val.type]" type="text">
							</el-input>
						</span>
						<span v-else>{{param1[index][val.type]}}</span>
					</td>
					<td>
						<span v-if="is_edit===true">
							<el-input size="small" style="width: 80px;" v-model="param3[index][val.type]" type="text">
							</el-input>
						</span>
						<span v-else>{{param3[index][val.type]}}</span>
					</td>
					<td>
						<span v-if="is_edit===true">
							<el-upload :action="uploadAction" list-type="picture-card" :headers="myHeaders"
								:on-success="(value)=> handleSuccess({index:index,type:val.type}, value)"
								:file-list="fileList[index][val.type]"
								:on-remove="(value)=> handleRemove({index:index,type:val.type}, value)"
								:before-upload="beforeUpload">
								<div>立即上传</div>
							</el-upload>
						</span>
						<span v-else v-for="(item,index) in images[index][val.type]"
							style="width: 100px;height: 100px;">
							<el-image :src="item" style="width: 100px;height: 100px;"></el-image>
						</span>
					</td>
					<td v-if="key==0" rowspan="5">
						{{average[list.id][index]}}
					</td>
					<td v-if="key==0 && is_edit===true" rowspan="5">
						<el-button type="danger" @click="deleteOption(index)" v-if="is_edit===true">删除</el-button>
						<el-button type="danger" @click="deleteOption(index)" v-else>没有权限</el-button>
					</td>
				</tr>

			</tbody>
			<tbody v-if="is_edit===true"  >
				<tr>
					<td colspan="9">
						<el-button class="edit_btn" type="primary" plain size="small" @click="add()">增加一组</el-button>
					</td>
				</tr>
			</tbody>
			</tr>
		</table>
		<el-dialog :visible.sync="dialogIntroVisible">
			文字说明 :{{intro_text}}
			<el-divider content-position="right"></el-divider>
			<el-link :href="item" target="_blank" v-for="(item,index) in intro_images_list" v-if="item!=''"
				:key="index"><img width="100px" height="100px" :src="item" alt=""></el-link>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: "CollectPest",
		props: {
			work_task_id: {
				type: Number,
				default: 0
			},
			is_edit: {
				type: Boolean,
				default: false
			},
			list: {
				type: Object,
				default: () => []
			},

		},
		data() {
			return {
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
				average: [],
				text: '',
				rowspan: 0,
				param1: this.makeParam1(),
				param2: this.makeParam2(),
				param3: this.makeParam3(),
				images: this.makeImages(),
				fileList: this.makeFileList(),
				dialogIntroVisible: false,
				intro_text: '',
				intro_images_list: '',
				total: 0,
                lists:{
					option_list:[],
				}, 
				 id:'',
				 
			}
		},
		created() {
			this.id=this.list.id
			
			this.computer()
			console.log("start")
			console.log(this.param1)
		},
		computed: {
		},
		methods: {
			computer() {		
				this.average[this.id]=[]
				 this.list.option_list.forEach((item, index) => {
					this.average[this.id][index] = 0,
					this.total=0;
						item.forEach((val, key) => {
							this.total+=( parseFloat(val.param1) + parseFloat(val
								.param2) + parseFloat(val.param3))
						})
						this.average[this.id][index]=this.total/15
				}) 
				
				console.log(this.average)
				this.lists=this.list
				//console.log(this.lists.option_list)
				return 1
			},
			deleteOption(index) {
				if (this.list.option_list.length == 1) {
					this.$message.error("至少保留一个")
					return false
				}
				this.list.option_list.forEach((val, key) => {
					if (index == key) {
						this.list.option_list.splice(val, 1)
					}

				})
				this.param1 = this.makeParam1()
				this.param2 = this.makeParam2()
				this.param3 = this.makeParam3()
				this.images = this.makeImages()
			},
			add() {
				let param=[{
							"type": 1,
							"name": "东",
							"param1": "",
							"param2": "",
							"param3": "",
							"images": []
						},
						{
							"type": 2,
							"name": "西",
							"param1": "",
							"param2": "",
							"param3": "",
							"images": []
						},
						{
							"type": 3,
							"name": "南",
							"param1": "",
							"param2": "",
							"param3": "",
							"images": []
						},
						{
							"type": 4,
							"name": "北",
							"param1": "",
							"param2": "",
							"param3": "",
							"images": []
						},
						{
							"type": 5,
							"name": "中",
							"param1": "",
							"param2": "",
							"param3": "",
							"images": []
						}
					]
				this.list.option_list.push(param)	
				//console.log(this.list.option_list)
				this.$set(this.param1,this.param1.length, this.makeParam11(this.list.option_list));
				this.$set(this.param2,this.param2.length, this.makeParam2(2));
				this.$set(this.param3,this.param3.length, this.makeParam3(2));
				this.$set(this.images,this.images.length, this.makeImages(2));
				this.$set(this.fileList,this.fileList.length, this.makeFileList(2));
			this.$set(this.list,"option_list", this.list.option_list);
			
			//console.log(this.param1)
			},
			
			makeParam11(option_list) {
				let arr = []
				//console.log(option_list)
				option_list.forEach((item, index) => {
					arr[index] = []
					
					console.log(item)
					item.forEach((val, key) => {
						
						//arr[index][val.type] = val.param1
						
					})
			
				})
					
				return arr
			},
			makeParam1() {
				let arr = []
				//console.log(this.list.option_list)
				this.list.option_list.forEach((item, index) => {
					arr[index] = []
					item.forEach((val, key) => {
						
						arr[index][val.type] = val.param1
						
					})

				})
		
				return arr
			},
			makeParam2(type=1) {
				let arr = []
				this.list.option_list.forEach((item, index) => {
					arr[index] = []
					item.forEach((val, key) => {
						if(type==1){
						arr[index][val.type] = val.param2
						}
					})

				})
				return arr
			},
			makeParam3(type=1) {
				let arr = []
				this.list.option_list.forEach((item, index) => {
					arr[index] = []
					item.forEach((val, key) => {
						if(type==1){
						arr[index][val.type] = val.param3
						}
					})

				})
				return arr
			},
			makeImages(type=1) {
				let arr = []
				this.list.option_list.forEach((item, index) => {
					arr[index] = []
					item.forEach((val, key) => {
						if(type==1){
						arr[index][val.type] = val.images
						}
					})

				})
				return arr
			},

			makeFileList(type=1) {
				let arr = []
				this.list.option_list.forEach((item, index) => {
					arr[index] = []
					item.forEach((val, key) => {
						arr[index][val.type] = []
						val.images.forEach((v, k) => {
							arr[index][val.type].push({
								url: v,
							    uid:k
							})
							
						})



					})

				})
				console.log(arr)
				return arr
			},
			openIntro(list) {
				this.dialogIntroVisible = true
				this.intro_text = list.remark
				this.intro_images_list = list.images
			},
			handleSuccess(res, response, file, fileList) {
				
				this.images[res.index][res.type].push(response.data)
				
		
			},
			handleRemove(res, file, fileList) {

				if (this.action == 1) {
					var url = file.response.data;
				} else {
					var url = file.url;
				}
				var index = this.images[res.index][res.type].indexOf(url)
				this.images[res.index][res.type].splice(index, 1);;
				//this.fileList[id].splice(index, 1);;
			},
			beforeUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPng = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				if (!isJPG && !isPng) {

					this.$message.error('上传图片只能是 JPG或PNG 格式!');
					return false
				} else {
					return true
				}
			},
		}
	}
</script>

<style>
	.crop {
		width: 90px;
		height: 90px;
		position: relative;

		&:before {
			content: '';
			width: 40px;
			height: 37px;
			background: url("../../assets/images/upLoad_03.png") no-repeat;
			background-size: cover;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-left: -20px;
			margin-top: -18.5px;
			z-index: 1;
		}

		&:after {
			content: '';
			width: 30px;
			height: 30px;
			background: url("../../assets/images/upLoad_01.png") no-repeat;
			background-size: cover;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-left: -15px;
			margin-top: -15px;
			z-index: 2;
		}

		img {
			width: 100%;
		}
	}
</style>
